<template>
  <div v-if="vx_billInfo" class="row">
    <div class="col-md-3 col-sm-3">
      <span class="fontSize20 title-color">乘客電話：</span>
      <span class="fontSize20">{{ phone }}</span>
    </div>
    <div class="col-md-3 col-sm-3">
      <span class="fontSize20 title-color">乘客稱呼：</span>
      <span class="fontSize20">{{ name }}</span>
    </div>
    <div class="col-md-3 col-sm-3">
      <span class="fontSize20 title-color">派單方式：</span>
      <span class="fontSize20">{{ method }}</span>
    </div>
    <div class="col-md-3 col-sm-3">
      <span class="fontSize20 title-color">需要幾輛：</span>
      <span class="fontSize20">{{ vx_billInfo.cars }}台</span>
      <button
        v-show="vx_billInfo.cars !== 1"
        class="btn-primary btn"
        @click="finishReserve"
      >
        直接完成訂單
      </button>
    </div>
  </div>
</template>

<script>
import { reqFinishReservation } from '@/api/reservation'
import { mapState, mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions('reservation', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    async finishReserve() {
      try {
        const { success, message } = await reqFinishReservation({
          reservationId: this.reservationInfo.billInfo.orderId,
        })
        if (success) {
          if (message.result) {
            Notification({
              title: '更新成功',
              type: 'success',
            })
            // update order detail
            this.vx_fetchOrderDetail()
          } else {
            Notification({
              title: '更新失敗',
              type: 'error',
            })
          }
        } else {
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  computed: {
    ...mapState('reserveModal', {
      vx_billInfo: 'billInfo',
      vx_passengerInfo: 'passengerInfo',
    }),
    phone() {
      const method = this.vx_billInfo.callMethod
      if (method === 1 || method === 2) {
        return this.vx_billInfo.passengerPhone
      }
      if (method === 0 || method === 3 || method === 4) {
        return this.vx_passengerInfo.passengerPhone
      }
      return this.vx_passengerInfo.phone
    },
    name() {
      const method = this.vx_billInfo.callMethod
      if (method === 1 || method === 2) {
        return this.vx_billInfo.passengerName
      }
      if (method === 0 || method === 3 || method === 4) {
        return this.vx_passengerInfo.passengerName
      }
      return this.vx_passengerInfo.name
    },
    method() {
      switch (this.vx_billInfo.acknowledgingOrderMethods) {
        case 0:
          return '應徵'
        case 1:
          return '搶單'
        case 2:
          return '指定'
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reserveModal/Top.vue